import {ApiRequest} from './request'
import {createOrUpdateSlider, getSliderSteps, destroySlider} from '../site/order'

const createSlider = function()
{
    // Get the range slider
    const rangeSlider = document.getElementById('slider-range-requests')

    // Stop if no range slider
    if(!rangeSlider) return

    // Create the slider instance
    try {

        const sliderData = getSliderSteps(window.products, rangeSlider.getAttribute('data-category'))

        destroySlider()

        createOrUpdateSlider(
            sliderData,
            'slider-range-requests',
            {
                tooltips: { to: function(value){
                        const currentProduct = sliderData.steps.find(product => {
                            return product.quantity == value
                        })
                        return `<div class="price">$ ${currentProduct.price}</div>
                                <div class="description">${currentProduct.comment.replaceAll('\n', '<br/>')}</div>`
                    }
                }
            }
        )
    } catch (e) {}
}

async function cancelDowngranding (e)
{
    e.preventDefault()

    const el = $(e.target)
    const elParent = el.parents('div.downgrate-btn-block')

    el.after('<span>canceling...</span>')
    el.remove()

    const result =  await ApiRequest(el.data('url'), null, 'POST', 'application/json', 'application/json')

    elParent.html(!result.success ? `<p>${result.message}</p>` : '')
}

const setup = function()
{
    $(document).on('click', '#cancel-downgranding', cancelDowngranding)

    window.createRequestsSlider = createSlider
}

export default function addRequests(app)
{
    $(setup)
}
